import { t } from 'i18next'

/**
 * Toggle the visibility of the FAQ section.
 * @param {HTMLElement} section - The FAQ section element.
 * @param {HTMLElement} button - The button element for toggling.
 */

const listWrapper = document.querySelector('[data-faq-wrapper]')

function showMoreFaqSection(section, button) {
  const openedItem = document.querySelector('.opened[data-faq-item]')
  if (!button.classList.contains('opened')) {
    button.textContent = `${t('showLess')}`
  } else {
    button.textContent = `${t('showMore')}`
    if (openedItem) {
      const answear = openedItem.querySelector('[data-faq-answear]')

      openedItem.classList.remove('opened')
      answear.style.height = '0'
      answear.style.marginTop = '0'
    }
  }
  listWrapper.style.maxHeight = ''
  button.classList.toggle('opened')
  section.classList.toggle('opened')
}

/**
 * Toggle the visibility of a FAQ item.
 * @param {HTMLElement} currListItem - The current FAQ item element.
 * @returns {function} - The event handler function.
 */

const observer = new IntersectionObserver(
  entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) {
        listWrapper.style.maxHeight =
          +window.getComputedStyle(listWrapper).maxHeight.replace('px', '') +
          entry.target.clientHeight +
          'px'
      }
    })
  },
  {
    root: listWrapper, // Вказати батьківський елемент як кореневий
    threshold: 0.5, // Поріг видимості елемента
  },
)

function toggleItem(currListItem) {
  return function () {
    const answearEl = currListItem.querySelector('[data-faq-answear]')

    if (currListItem.classList.contains('opened')) {
      currListItem.classList.remove('opened')
      answearEl.style.height = '0'
      answearEl.style.marginTop = '0'
      listWrapper.style.maxHeight = ''
    } else {
      const openedFaqItems = document.querySelectorAll('.opened[data-faq-item]')
      openedFaqItems.forEach(el => {
        el.classList.remove('opened')
        const answear = el.querySelector('[data-faq-answear]')
        answear.style.height = '0'
        answear.style.marginTop = '0'
      })

      currListItem.classList.add('opened')
      currListItem.addEventListener(
        'transitionend',
        function () {
          observer.observe(currListItem)
          setTimeout(() => {
            observer.disconnect()
          }, 150)
        },
        { once: true },
      )
      answearEl.style.height = answearEl.scrollHeight + 'px'
      answearEl.style.marginTop = '10px'
    }
  }
}

const showMoreWrapper = document.querySelector('[data-show-more-faq]')
const showMoreText = document.querySelector('[data-show-more-text]')

if (showMoreWrapper) {
  // Create a handler for showMoreWrapper
  const showMoreFaqSectionHandler = () => showMoreFaqSection(listWrapper, showMoreText)
  showMoreWrapper.addEventListener('click', showMoreFaqSectionHandler)
}

const faqBtns = document.querySelectorAll('[data-btn-plus]')

faqBtns.forEach(el => {
  // Create a handler for each faqBtn
  const toggleItemHandler = toggleItem(el.closest('[data-faq-item]'))
  el.addEventListener('click', toggleItemHandler)
})
